import React from "react";

type Props = {
  text: string;
  className?: string;
};

export const BoldQuotedText: React.FC<Props> = ({ text, className }) => {
  if (!text) {
    return null;
  }
  return (
    <>
      {text.split('"').map((chunk, index) =>
        index % 2 === 0 ? (
          <span className={className} key={index}>
            {chunk}
          </span>
        ) : (
          <b className={className} key={index}>
            "{chunk}"
          </b>
        )
      )}
    </>
  );
};
